<ng-container *rxLet="vm$; let vm;">
  <app-form-select
    [formControl]="formControl"
    label="Repair Category"
    [data]="vm.repairCategories"
    [loading]="vm.loading"
    (itemSelected)="repairTypeCategoryChanged.emit($event)"></app-form-select>
</ng-container>
